import createDailyAgendaWidget from './createDailyAgendaWidget';
import type { EditorAPI } from '#packages/editorAPI';

export default ({ editorAPI }: { editorAPI: EditorAPI }) =>
  createDailyAgendaWidget({
    editorAPI,
  });
